import { useState } from "react";
import Slider from "react-slick";
import { useQuery } from "react-query";
import { getMainBanner, getMainNews } from "../../service";
import { Box, Button, Flex, Heading, Image, Link, Text, Center, FormControl, Input, useMediaQuery, Badge, FormErrorMessage, useToast } from "@chakra-ui/react";
import Tab from "../../Component/Tab";
import SlideArrow from "../../Component/Button/SlideArrow";
import { JoinBannerSection, MiddleBannerSection, NewsSection, TopBannerSection, WorkBannerSection, WorkBannerSectionFull } from "./style";
import { newsTabEn as newsTab, channelList, channelListEn } from "./meta";
import { kboardDate, stripTags } from "../../util";
import WorkItem from "./WorkItem";
import { theme } from "../../assets/style/theme";
import { responsiveValue } from "../../assets/style/defaultTheme";
import LineBreakOnMobile from "../../Component/Br/LineBreakOnMobile";
import { useForm } from "react-hook-form";
import axios from "axios";

type Props = {};

function LandingEn({}: Props) {
	const [topBannerCurrent, setTopBannerCurrent] = useState(1);
	const [newTabSelected, setNewsTabSelected] = useState(0);

	const toast = useToast();

	const { isLoading: topBannerIsLoading, error: errorTopBanner, data: topBanner } = useQuery("getMainBannerTop", () => getMainBanner("top_en", -1));
	const { isLoading: newsIsLoading, error: errornews, data: news } = useQuery(["getMaiNews", newTabSelected], () => getMainNews(newsTab[newTabSelected].boardId, 3));

	const [isMobile] = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`);

	const topBannerSetting = {
		infinite: true,
		speed: 500,
		slidesToShow: 1,
		slidesToScroll: 1,
		nextArrow: <SlideArrow color="gr" />,
		prevArrow: <SlideArrow color="gr" />,
		afterChange: (index: number) => {
			setTopBannerCurrent(index + 1);
		},
	};

	const onClickNewsTab = (item: any, index: number) => {
		setNewsTabSelected(index);
	};

	const sectionSidePadding = { base: "4%", lg: "0" };

	const {
		handleSubmit,
		register,
		formState: { errors },
	} = useForm();

	const onSubscribe = (values: any) => {
		const stibeeEndpoint = "https://stibee.com/api/v1.0/lists/kNI7z7yQacvThCROHW3T3dPVca-T/public/subscribers";
		const formData = new FormData();
		formData.append("email", values.email);
		formData.append("name", values.name);
		axios.post(stibeeEndpoint, formData).then((res) => {
			const msg = res.data.split("<p>")[1].split("</p>")[0];
			toast({
				description: msg,
				status: "success",
				position: "top",
			});
		});
	};

	return (
		<>
			{!topBannerIsLoading && topBanner && (
				<TopBannerSection>
					<Slider {...topBannerSetting}>
						{topBanner.map((item: any, index: number) => (
							<div key={index}>
								<Link href={item.meta.mainbanner_url} target={item.meta.mainbanner_target}>
									{isMobile ? (
										// <Box backgroundImage={item?.meta?.mainbanner_mobile_image?.url}  w="100%" backgroundPosition="50% 50%" backgroundSize="cover" >
										// </Box>
										<Image src={item?.meta?.mainbanner_mobile_image?.url} w="100%" />
									) : (
										<Box backgroundImage={item.featured_full} h={{ base: "480px", lg: "1000px" }} w="100%" backgroundPosition="50% 50%" backgroundSize="cover"></Box>
									)}
								</Link>
							</div>
						))}
					</Slider>
					<div className="current">
						{topBannerCurrent} / {topBanner.length}
					</div>
				</TopBannerSection>
			)}

			{/* {!middleBannerIsLoading && middleBanner && (
				<Box maxW="900" margin="0 auto" pt={{ base: "10", lg: "20" }} pb={{ base: "10", lg: "20" }}>
					<MiddleBannerSection>
						{middleBanner.map((item: any, index: number) => (
							<div key={index}>
								<Link href={item.meta.mainbanner_url} target={item.meta.mainbanner_target}>
									<Image src={item.featured_full} h="54px" objectFit="contain" />
								</Link>
							</div>
						))}
					</MiddleBannerSection>
				</Box>
			)} */}

			<Box textAlign="center" pt="36" pb="36" pr={sectionSidePadding} pl={sectionSidePadding}>
				<Heading size="2xl" color="b.gr" pb="6">
					Korea SHE Foundation is

				</Heading>
				<Heading fontSize={{ base: "2.5rem", lg: "3rem" }} color="b.bk" lineHeight="1.2" pb="6">
        Creating a safe and sustainable society, like a forest
				</Heading>
				<Text pb="6" lineHeight="1.5">
				We believe in the virtue of “forest” and the power of
“sharing.” We will cultivate talents who can lead the future
in the fields of environment, safety, and health.<br/> In order to
solve the problems and find feasible alternatives, we will
cooperate and communicate with various participants in
our society.
				</Text>
				{/* <Button size="lg" colorScheme="dgr" fontSize="xl">
					<a href="http://koreashe.org/intro" target="_blank">
						숲과나눔 사용설명서 바로가기
					</a>
				</Button> */}
			</Box>

			<Box bgColor="b.llg" pt={{ base: "12", lg: "32" }} pb={{ base: "16", lg: "32" }} pr={sectionSidePadding} pl={sectionSidePadding}>
				<NewsSection>
					<Box maxW="1200" margin="0 auto" pb={{ base: "8", lg: "14" }}>
						<Flex>
							<Heading size="4xl" color="b.bk" paddingRight="4">
							Korea SHE Foundation's NEWS

							</Heading>
						</Flex>
					</Box>
					<Box maxW="1200" margin="0 auto">
						<Tab list={newsTab} selectedItemIndex={newTabSelected} onClickItem={onClickNewsTab} size={isMobile ? "lg" : "2xl"} />
						{!newsIsLoading && news && (
							<Flex justify="space-between" direction={responsiveValue.flexBoxDirection}>
								{news.items.map((item: any, index: number) => (
									<Link key={index} href={`/en/board?mode=view&board_id=${item.board_id}&post_id=${item.uid}`}>
										<Box w={{ base: "100%", lg: "sm" }}>
											<Image src={item.featured_full} objectFit="cover" borderRadius="16px 16px 0 0" />
											<Box padding="6" bgColor="b.wh" borderRadius="0 0 16px 16px" minH={{ base: "0", lg: "245px" }}>
												<Heading fontSize="xl" lineHeight="1.4" mb="4" noOfLines={2}>
													{stripTags(item.title)}
												</Heading>
												<Text color="b.g" lineHeight="1.4" mb="5" noOfLines={3}>
													{stripTags(item.content)}
												</Text>
												<Text color="b.g" fontSize="sm" pb="4">
													{kboardDate(item.date)}
												</Text>
											</Box>
										</Box>
									</Link>
								))}
							</Flex>
						)}
						<Center pt="12">
							<a href={`/en/board/?board_id=${newsTab[newTabSelected].boardId}`}>
								<Button size="lg" colorScheme="dgr">
									More {newsTab[newTabSelected].label} +
								</Button>
							</a>
						</Center>
					</Box>
				</NewsSection>
			</Box>
			<Box pt={{ base: "12", lg: "36" }} pb={{ base: "12", lg: "36" }} pr={sectionSidePadding} pl={sectionSidePadding} backgroundImage="/images/main/channel_bg.png" backgroundRepeat="no-repeat" backgroundPosition="100% 100%">
				<Box maxW="1200" margin="0 auto" pb="14">
					<Flex>
						<Heading size="4xl" color="b.g" paddingRight="4" lineHeight="1.4">
						Korea SHE Foundation's Channel
						</Heading>
					</Flex>
				</Box>

				<Box maxW="1200" margin="0 auto" pb={{ base: "0", lg: "14" }}>
					<Flex justify="space-between" direction={responsiveValue.flexBoxDirection}>
						{channelListEn.map((item: any, index: number) => (
							<Link href={item.url} target="_blank" key={index}>
								<Box
									w={{ base: "100%", lg: "282px" }}
									h={{ base: "80px", lg: "260px" }}
									bgColor="b.gr"
									borderRadius="16"
									padding="4"
									key={index}
									borderStyle="solid"
									borderWidth="1px"
									borderColor={item.bg}
									backgroundColor="b.wh"
									boxSizing="border-box"
									mb={{ base: "4", lg: "0" }}
								>
									<Flex direction={{ base: "row", lg: "column" }} alignItems={{ base: "center", lg: "start" }} justifyContent="space-between">
										<Box w="80px" textAlign="center" pl="2">
											<Image src={`/images/icons/${item.value}_c.svg`} h={{ base: "40px", lg: "50px" }} objectFit="cover" mt={{ base: "0", lg: "20" }} mb={{ base: "0", lg: "6" }} />
										</Box>
										<Box flex="1">
											<Flex align="center">
												<Heading size="2xl" color="b.bk" paddingLeft="2">
													{item.label}
												</Heading>
												<Image src="/images/icons/link.svg" w={{ base: "18px", lg: "32px" }} objectFit="cover" />
											</Flex>
										</Box>
									</Flex>
								</Box>
							</Link>
						))}
					</Flex>
				</Box>
			</Box>

		</>
	);
}

LandingEn.defaultProps = {};

export default LandingEn;
